import { useQuery } from '@apollo/client'
import { Navigate, useParams } from 'react-router-dom'
import { GET_FACILITY_FLOOR_AND_VERSION_IDS } from '~/client/queries'
import { ErrorMessageBlock } from '~/components/ErrorMessageBlock'
import { HomeButton } from '~/components/HomeButton'
import { Loader } from '~/ui/Loader'
import { Alert } from '~/ui/Alert'

export const ShortUrlRedirect = () => {
  const { id } = useParams<'id'>()
  const { data, loading, error } = useQuery(GET_FACILITY_FLOOR_AND_VERSION_IDS, { variables: { facilityId: id ?? '' } })
  const facility = data?.Facility

  if (loading) {
    return <Loader variant="centered" />
  } else if (error || !facility) {
    return (
      <div className="flex flex-col gap-3">
        <Alert severity="error" className="mb-3">
          <div className="flex flex-col gap-3 w-full">
            <p>
              {!facility
                ? `Unable to find a facility with the provided id${id ? `: ${id}` : ''}`
                : 'Encountered error while trying to get facility data.'}
            </p>
            {error instanceof Error ? <ErrorMessageBlock>{error.message}</ErrorMessageBlock> : null}
          </div>
        </Alert>
        <HomeButton className="mx-auto" />
      </div>
    )
  }

  const floor = facility.floors?.[0]
  const version = floor?.versions?.[0]

  if (!floor || !version) {
    const missingValues = [floor && 'areas', version && 'versions']
      .filter((message): message is string => !!message)
      .join(' or ')
    return (
      <div className="flex flex-col gap-3">
        <Alert severity="error">This facility does not have any {missingValues} associated to it.</Alert>
        <HomeButton className="mx-auto" />
      </div>
    )
  }

  return <Navigate replace to={`/facility/${id}/area/${floor.id}/version/${version.id}`} />
}
